__webpack_require__.p = "https://staging.digital-menu.app/";